module.exports = __webpack_public_path__ + "img/10.6f909af8.png";